<template>
	<div class="menu-layout">
		<slot name="activator" :click="onActivatorClick">
			<TeamingButton
				class="menu-layout__activator"
				:leftIcon="['fas', 'caret-down']"
				size="SMALL"
				type="QUATERNARY"
				@click="onActivatorClick"
			/>
		</slot>
		<OverlayPanel
			ref="overlayPanel"
			:class="overlayClasses"
		>
			<slot name="menu" :hide="onHide">
				<div>(menu implementation here)</div>
			</slot>
		</OverlayPanel>
	</div>
</template>

<script>
import TeamingButton from "./buttons/TeamingButton.vue";

export default {
	name: "MenuLayout",
	emits: [ "toggle", "hide", ],
	components: {
		TeamingButton,
	},
	props: {
		overlayClassName: {
			type: String,
			default: "",
		},
	},
	computed: {
		overlayClasses() {
			return `${ this.overlayClassName }`.trim();
		},
	},
	methods: {
		async onActivatorClick( e ) {
			await this.$nextTick();
			if ( !this.$refs.overlayPanel ) {
				return;
			}
			await this.$nextTick();
			this.$refs.overlayPanel.toggle( e );
			this.$emit( "toggle" );
		},
		async onHide() {
			await this.$nextTick();
			if ( !this.$refs.overlayPanel ) {
				return;
			}
			await this.$nextTick();
			this.$refs.overlayPanel.hide();
			this.$emit( "hide" );
		},
	},
};
</script>

<style lang="scss" scoped></style>
